export default "__VITE_ASSET__CXDaYcbi__"